import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { css } from "styled-components";

wishListCardStyles.actionAddToCartButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `, // keep text from wrapping
};

wishListCardStyles.actionGridItem = {
    width: [2, 2, 4, 3, 3],
    align: "top",
    css: css`
        justify-content: flex-end;
    `,
};

wishListCardStyles.wishListInfoGridItem = {
    width: [10, 10, 8, 9, 9],
    align: "middle",
};
